module.exports = __webpack_public_path__ + "224ab56c83658e13ee6f044f66a95374.svg";